define(['exports', 'react-dom'], function (exports, _reactDom) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PAGE_LOADER_STYLE = undefined;
  exports.disablePageScroll = disablePageScroll;
  exports.enablePageScroll = enablePageScroll;
  exports.setFocusOnTextField = setFocusOnTextField;

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PAGE_LOADER_STYLE = exports.PAGE_LOADER_STYLE = {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0)',
    zIndex: 10
  };

  function disablePageScroll() {
    var el = document.getElementsByTagName('html')[0];
    el.style.overflow = 'hidden';
  }

  function enablePageScroll() {
    var el = document.getElementsByTagName('html')[0];
    el.style.overflow = 'auto';
  }

  // Set the focus on the field also move the focus to the end of the input text
  function setFocusOnTextField(textfield) {
    var el = _reactDom2.default.findDOMNode(textfield).getElementsByTagName('input')[0];
    el.selectionStart = el.selectionEnd = el.value.length;
    el.focus();
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/utils/uiHelper.js
// module id = 260
// module chunks = 0